import { useGetList } from "react-admin";
import { grants } from "../backoffice.access_control";
import { canViewPayoutOverview, usesStripePayments } from "../model/PaymentConfiguration";
import type { AutovioPayoutRecord } from "../providers/autovioPayoutProvider";
import type { DrivingSchool } from "../providers/drivingSchoolsProvider";

export function usePayoutOverviewAccess(drivingSchool: DrivingSchool | undefined) {
  const hasGrant = grants.has("viewPayoutInformation");
  const checkPayoutHistory = hasGrant && !!drivingSchool && !usesStripePayments(drivingSchool);
  const { total, isLoading, error } = useGetList<AutovioPayoutRecord>(
    "autovioPayouts",
    {
      filter: { drivingSchoolId: drivingSchool?.uid },
      pagination: { page: 1, perPage: 1 },
      sort: { field: "payoutDate", order: "DESC" },
    },
    { enabled: checkPayoutHistory, keepPreviousData: false },
  );

  return {
    canView: hasGrant && canViewPayoutOverview(drivingSchool, total),
    isLoading: checkPayoutHistory && isLoading,
    error: checkPayoutHistory ? error : null,
  };
}
